import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { DataFormatService } from './data-format.service';
import { environment } from '../../../environments/environment';
import { FilterModel } from '../../features/shared/models/filter-list.model';
import { ResultListedData } from '../../features/shared/models/response-result.model';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class BaseClientService<T> extends DataFormatService {
  private apiUrl: string = environment.apiUrl;
  private readonly endpoint: string;
  header = {
    headers: {
      'Authorization': '',
      'Content-Type': 'application/json',
    },
  };

  constructor(@Inject(String) endpoint: string, private http: HttpClient) {
    super();

    this.endpoint = endpoint;
    this.header.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token');
  }

  public get<T>(route: string ='') {
    return this.http.get<T>(this.createCompleteRoute(`${this.endpoint}/${route}`), this.header);
  }

  public getPaging(data: FilterModel, additionalQuery?: any) {
    let queryString = DataFormatService.objectToQueryString(data);

    return this.get<ResultListedData<T>>(`pagination?${queryString}&${additionalQuery? additionalQuery : ''}`);
  }

  public create<T>(body: any, route: string ='') {
    return this.http.post<T>(this.createCompleteRoute(`${this.endpoint}/${route}`), body, this.header);
  }

  public patch<T>(body: any, route: string ='') {
    return this.http.patch<T>(this.createCompleteRoute(`${this.endpoint}/${route}`), body, this.header);
  }

  public update<T>(body: any, route: string ='', id?: number) {
    return this.http.put<T>(this.createCompleteRoute(`${this.endpoint}/${route}`), JSON.stringify(body), this.header);
  }

  public delete(id: number, route: string ='') {
    return this.http.delete<T>(`${this.createCompleteRoute(`${this.endpoint}/${route}`)}${id}`, this.header);
  }

  public deleteFullRoute(route: string ='') {
    return this.http.delete(`${this.createCompleteRoute(`${this.endpoint}/${route}`)}`, this.header);
  }

  public customRequest<T>(
    method: 'GET' | 'POST' | 'PUT' | 'DELETE',
    body: any,
    reportProgress: boolean = false,
    responseType?: 'arraybuffer' | 'blob' | 'json' | 'text',
    route?: string,
  ) {
    const req = new HttpRequest(method, this.createCompleteRoute(`${this.endpoint}/${route}`), body, {
      headers: new HttpHeaders().set('Authorization', 'Bearer ' + localStorage.getItem('token')),
      reportProgress: reportProgress,
      responseType: responseType,
      withCredentials: false,
    });

    return this.http.request<T>(req);
  }

  downloadFile(url: string, filename: string) {
    return this.http
      .get(url, { responseType: 'blob' })
      .subscribe(blob => saveAs(blob, filename));
  }

  createCompleteRoute(route: string) {
    const middlePath = this.apiUrl.split('').pop() !== '/' && route !== null && route[0] !== '/' ? '/' : '';
    return `${this.apiUrl}${middlePath}${route}`;
  }
}
